import { FC } from 'react'
import WarningIcon from '@mui/icons-material/FmdBad'
import Chip from '@mui/material/Chip'
import { SxProps } from '@mui/material'
import { Theme } from '@mui/material'

type Props = {
  size?: "small" | "medium"
  sx?: SxProps<Theme>
  isShortLabel?: boolean
}

export const SensorStagingLabel: FC<Props> = ({ size = 'small', sx = {}, isShortLabel = false }) => (
  <Chip
    variant="outlined"
    color="warning"
    label={isShortLabel ? "S" : "Staging"}
    avatar={<WarningIcon />}
    size={size}
    sx={sx}
  />
)
